<form [formGroup]="form">
    <rask-input aid="huvudkodInternnummer" label="Huvudkod Internnr" formControlName="huvudkodInternnummer" [readonly]="true"></rask-input>
    <rask-input aid="besokAdress" label="Besöksadress" formControlName="besokAdress" [readonly]="true"></rask-input>
    <rask-input aid="ordernummer" label="Ordernummer" formControlName="ordernummer" [readonly]="true"></rask-input>
    <rask-input aid="sumLevrader" label="Summa leveransrader" [value]="orderHeader.summaLeveransrader | number: '0.0'" [readonly]="true"></rask-input>
    <rask-input aid="mattslag" label="texts.mattslag" formControlName="mattslag" [readonly]="true"></rask-input>
    <rask-datepicker
        formControlName="periodFrom"
        label="Från och med"
        [rule]="validation.periodFrom"
        [required]="true">
    </rask-datepicker>
    <rask-datepicker
        formControlName="periodTom"
        label="Till och med"
        [rule]="validation.periodTom"
        [required]="true">
    </rask-datepicker>
</form>
